// extracted by mini-css-extract-plugin
export default {"container":"Menus_container__Qirel","item":"Menus_item__wo2mL"};